import {combineReducers} from 'redux'
import {authentication} from './AuthenticationReducer'
import { insights } from './InsightsReducer'

const rootReducer = combineReducers({
    authentication, 
    insights, 
})

export default rootReducer